import React from 'react';
import NavBar from '../NavBar/NavBar';

const Blogs = () => {
    return (
        <div>
            <NavBar></NavBar>
            <h2>Blogs are coming soon</h2>
        </div>
    );
};

export default Blogs;